import axios from 'axios';

const setAnsweringDefaultEnabled = async (
  subscriptionId: string,
  defaultEnabled: boolean,
) => {
  await axios.put(`/answering_subscription/${subscriptionId}/default_enabled`, {
    defaultEnabled,
  });
};

export default setAnsweringDefaultEnabled;
